import classNames from "classnames";
import baseAmountRowStyles from "./AmountRowBase.module.css";

import type { JSX } from "react";
import { ValueWithCurrency } from "../ValueWithCurrency";

type RichLabelAmountRowProps = {
  htmlLabel: JSX.Element;
  value?: number;
  isTotal?: boolean;
};

const RichLabelAmountRow = (props: RichLabelAmountRowProps): JSX.Element => {
  const { htmlLabel, value, isTotal = false } = props;

  const rowClasses = classNames(baseAmountRowStyles.amountRow, { [baseAmountRowStyles.totalRowLarge]: isTotal });
  return (
    <tr className={rowClasses}>
      <td>{htmlLabel}</td>
      <td className={baseAmountRowStyles.amount}>
        <ValueWithCurrency value={value!} />
      </td>
    </tr>
  );
};

export { RichLabelAmountRow };
